import type { ZodError } from 'zod';
import z from 'zod';

export * from './BaseError.ts';
export { default as errorCodes } from './codes.ts';
export * from './HttpErrors.ts';
export { default as errorMessages } from './messages.ts';

z.config({
  customError: (issue) => {
    if (issue.input === undefined) {
      return 'Required';
    }
    return issue.message;
  },
});

// tofix: what's the difference between formatZodIssue and formatZodError?
export const formatZodIssue = (issue: ZodError['issues'][0]): string => {
  const { path, message } = issue;
  let result = `- ${message}`;
  if (path.length) result += ` at path: ${path.join('.')}`;
  return result;
};

export const formatZodIssues = (issues: ZodError['issues'], delimiter = '; '): string => issues.map(formatZodIssue).join(delimiter);

export const formatZodError = (error: ZodError) => {
  let value = '';
  for (const err of error.issues) {
    const path = err.path.join('.');
    const token = `${path}: ${err.message}`;
    value += `${token}\n`;
  }
  value = value.trim();
  return value;
};

export const formatZodErrors = (errors: ZodError[]) => errors.map(formatZodError).join('; ');
